import focusTrap from '../modules/focusTrap';

const mobileSidenav = {
	button: document.querySelector('.mobile-subnav-toggle'),
	sidebar: document.querySelector('.sidebar'),
	wrapper: document.querySelector('.sidebar--wrap'),
	buttonContainer: document.querySelector('.mobile-subnav-control')
};
mobileSidenav.open = function () {
	mobileSidenav.sidebar.setAttribute('aria-hidden', 'false');
	mobileSidenav.button.setAttribute('aria-expanded', 'true');
	mobileSidenav.sidebar.classList.add('sidebar-open');
	mobileSidenav.sidebar.focus();
	//document.body.classList.add('sidebar-active');
};

mobileSidenav.close = function () {
	mobileSidenav.sidebar.setAttribute('aria-hidden', 'true');
	mobileSidenav.button.setAttribute('aria-expanded', 'false');
	mobileSidenav.sidebar.classList.remove('sidebar-open');
	mobileSidenav.button.focus();
	//document.body.classList.remove('sidebar-active');
};

mobileSidenav.toggleMenu = function () {
	if (mobileSidenav.sidebar.classList.contains('sidebar-open')) {
		mobileSidenav.close();
	} else {
		mobileSidenav.open();
	}
};

if (mobileSidenav.button) {
	mobileSidenav.button.addEventListener('click', mobileSidenav.toggleMenu);

	let footer = document.querySelector('.site-footer');
	if (footer) {
		footer.classList.add('has-mobile-nav-menu');
	}

	// close on escape
	window.addEventListener('keyup', function (event) {
		if (event.keyCode == 27) {
			mobileSidenav.close();
		}
	});

	//focusTrap(mobileSidenav.wrapper);
}
